<script setup lang="ts">
import LoginDialog from '@/components/login-dialog.vue'
</script>

<template>
  <div>
    <router-view></router-view>
    <login-dialog />
  </div>
</template>

<style scoped>
</style>
